import { useEffect, useState } from "react";
import useInactivity from "../hooks/useInactivity";
import { WysiwygDisplay } from "./WysiwygDisplay";

export const CourseBasic = ({ lesson, controls, setControls }) => {
    const { isInactive, isTabInactive } = useInactivity();
    const timer = lesson?.timer;
    const [countdown, setCountdown] = useState(timer || 0);

    useEffect(() => {
        if (!timer) {
            // No timer, lesson is immediately available
            setControls({ state: 'ended' });
            return;
        }
        
        // Initialize countdown with timer value
        setCountdown(timer);
    }, [timer, setControls]);

    useEffect(() => {
        if (countdown > 0) {
            setControls({state: 'counting', countdown: countdown})
  
            const intervalId = setInterval(() => {
                setCountdown((prevCountdown) => prevCountdown - 1);
            }, 1000);
  
            return () => clearInterval(intervalId);
        } else if (countdown === 0 && timer) {
            setControls({
              state: 'ended'
            });
        }
    }, [countdown, setControls, timer]);

    useEffect(() => {
        if (isInactive || isTabInactive) {
            console.log("User is inactive");
        }
    }, [isInactive, isTabInactive]);

    return (
        <div>
            <h2>{lesson?.title}</h2>
            <WysiwygDisplay data={lesson?.description} />
        </div>
    );
};
